import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import "./assets/css/global.css";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";
import Main from "./pages/Main";
import Agreement from "./pages/Agreement";

function App() {
    //  privacy, terms

    return (
        <>
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/agreement/:type" element={<Agreement />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </BrowserRouter>
        </>
    );
}
export default App;
